import ThemeSwitcher from './theme/ThemeSwitcher';

function Header() {
    return (
      <header>
        <ThemeSwitcher />
      </header>
    );
}

export default Header;